/**
 * What a flat per-group price (typePrice 3) is charged per: one quad, one
 * buggy, one boat, one table. Pure, so the API can name the unit in what
 * MaJourneys AI says ("350 MAD per quad") as the booking screens do.
 * Moved here from @majourneys/booking, which re-exports it.
 */
export type BookingUnit = "group" | "quad" | "buggy" | "jet_ski" | "boat" | "twizy" | "car" | "table";

const UNIT_BY_CATEGORY_SLUG: Record<string, BookingUnit> = {
  quad: "quad",
  buggy: "buggy",
  "jet-ski": "jet_ski",
  boats: "boat",
  // A club sells a table for the night at a flat price (Leone, owner
  // 2026-10-12): "4,000 MAD per group" read as a cover charge for the party.
  nightclubs: "table",
};

/**
 * Some vehicles do not have a category of their own, a Twizy tour is filed
 * under City Tour next to walking and e-bike tours, so the category cannot
 * name the unit. Those are pinned by activity slug until the unit becomes a
 * field on the activity itself.
 */
const UNIT_BY_ACTIVITY_SLUG: Record<string, BookingUnit> = {
  "electric-twizy-tour-in-marrakech": "twizy",
  "2cv-vintage-car-tour-in-marrakech": "car",
};

export function resolveBookingUnit(
  categorySlug?: string | null,
  activitySlug?: string | null,
): BookingUnit {
  if (activitySlug) {
    const pinned = UNIT_BY_ACTIVITY_SLUG[activitySlug.trim().toLowerCase()];
    if (pinned) return pinned;
  }
  if (!categorySlug) return "group";
  return UNIT_BY_CATEGORY_SLUG[categorySlug.trim().toLowerCase()] ?? "group";
}

